/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 220
() {

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  // Gets the template name from the body class if template is not already populated
  var Moonbase = window.Moonbase || {};
  if (Moonbase.template === '') {
    if (document.body.classList.value.indexOf('template') > -1) {
      var _iterator = _createForOfIteratorHelper(document.body.classList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var className = _step.value;
          if (className.indexOf('template') > -1) {
            Moonbase.template = className.replace('template-', '');
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
})();

/***/ },

/***/ 560
() {

/* IE Polyfull */

if (typeof Object.assign != "function") {
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      "use strict";

      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };
    return function from(arrayLike) {
      var C = this;
      var items = Object(arrayLike);
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== "undefined") {
        if (!isCallable(mapFn)) {
          throw new TypeError("Array.from: when provided, the second argument must be a function");
        }
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }
      var len = toLength(items.length);
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
      var k = 0;
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      A.length = len;
      return A;
    };
  }();
}

/***/ },

/***/ 76
(module) {

// get successful control from form and assemble into object
// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

// types which indicate a submit action and are not successful controls
// these will be ignored
var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

// node names which could be successful controls
var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

// Matches bracket notation.
var brackets = /(\[[^\[\]]*\])/g;

// serializes form fields
// @param form MUST be an HTMLForm element
// @param options is an optional argument to configure the serialization. Default output
// with no options specified is a url encoded string
//    - hash: [true | false] Configure the output type. If true, the output will
//    be a js object.
//    - serializer: [function] Optional serializer function to override the default one.
//    The function takes 3 arguments (result, key, value) and should return new result
//    hash and url encoded str serializers are provided with this module
//    - disabled: [true | false]. If true serialize disabled fields.
//    - empty: [true | false]. If true serialize empty fields
function serialize(form, options) {
    if (typeof options != 'object') {
        options = { hash: !!options };
    }
    else if (options.hash === undefined) {
        options.hash = true;
    }

    var result = (options.hash) ? {} : '';
    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

    var elements = form && form.elements ? form.elements : [];

    //Object store each radio and set if it's empty or not
    var radio_store = Object.create(null);

    for (var i=0 ; i<elements.length ; ++i) {
        var element = elements[i];

        // ingore disabled fields
        if ((!options.disabled && element.disabled) || !element.name) {
            continue;
        }
        // ignore anyhting that is not considered a success field
        if (!k_r_success_contrls.test(element.nodeName) ||
            k_r_submitter.test(element.type)) {
            continue;
        }

        var key = element.name;
        var val = element.value;

        // we can't just use element.value for checkboxes cause some browsers lie to us
        // they say "on" for value when the box isn't checked
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
            val = undefined;
        }

        // If we want empty elements
        if (options.empty) {
            // for checkbox
            if (element.type === 'checkbox' && !element.checked) {
                val = '';
            }

            // for radio
            if (element.type === 'radio') {
                if (!radio_store[element.name] && !element.checked) {
                    radio_store[element.name] = false;
                }
                else if (element.checked) {
                    radio_store[element.name] = true;
                }
            }

            // if options empty is true, continue only if its radio
            if (val == undefined && element.type == 'radio') {
                continue;
            }
        }
        else {
            // value-less fields are ignored unless options.empty is true
            if (!val) {
                continue;
            }
        }

        // multi select boxes
        if (element.type === 'select-multiple') {
            val = [];

            var selectOptions = element.options;
            var isSelectedOptions = false;
            for (var j=0 ; j<selectOptions.length ; ++j) {
                var option = selectOptions[j];
                var allowedEmpty = options.empty && !option.value;
                var hasValue = (option.value || allowedEmpty);
                if (option.selected && hasValue) {
                    isSelectedOptions = true;

                    // If using a hash serializer be sure to add the
                    // correct notation for an array in the multi-select
                    // context. Here the name attribute on the select element
                    // might be missing the trailing bracket pair. Both names
                    // "foo" and "foo[]" should be arrays.
                    if (options.hash && key.slice(key.length - 2) !== '[]') {
                        result = serializer(result, key + '[]', option.value);
                    }
                    else {
                        result = serializer(result, key, option.value);
                    }
                }
            }

            // Serialize if no selected options and options.empty is true
            if (!isSelectedOptions && options.empty) {
                result = serializer(result, key, '');
            }

            continue;
        }

        result = serializer(result, key, val);
    }

    // Check for all empty radio buttons and serialize them with key=""
    if (options.empty) {
        for (var key in radio_store) {
            if (!radio_store[key]) {
                result = serializer(result, key, '');
            }
        }
    }

    return result;
}

function parse_keys(string) {
    var keys = [];
    var prefix = /^([^\[\]]*)/;
    var children = new RegExp(brackets);
    var match = prefix.exec(string);

    if (match[1]) {
        keys.push(match[1]);
    }

    while ((match = children.exec(string)) !== null) {
        keys.push(match[1]);
    }

    return keys;
}

function hash_assign(result, keys, value) {
    if (keys.length === 0) {
        result = value;
        return result;
    }

    var key = keys.shift();
    var between = key.match(/^\[(.+?)\]$/);

    if (key === '[]') {
        result = result || [];

        if (Array.isArray(result)) {
            result.push(hash_assign(null, keys, value));
        }
        else {
            // This might be the result of bad name attributes like "[][foo]",
            // in this case the original `result` object will already be
            // assigned to an object literal. Rather than coerce the object to
            // an array, or cause an exception the attribute "_values" is
            // assigned as an array.
            result._values = result._values || [];
            result._values.push(hash_assign(null, keys, value));
        }

        return result;
    }

    // Key is an attribute name and can be assigned directly.
    if (!between) {
        result[key] = hash_assign(result[key], keys, value);
    }
    else {
        var string = between[1];
        // +var converts the variable into a number
        // better than parseInt because it doesn't truncate away trailing
        // letters and actually fails if whole thing is not a number
        var index = +string;

        // If the characters between the brackets is not a number it is an
        // attribute name and can be assigned directly.
        if (isNaN(index)) {
            result = result || {};
            result[string] = hash_assign(result[string], keys, value);
        }
        else {
            result = result || [];
            result[index] = hash_assign(result[index], keys, value);
        }
    }

    return result;
}

// Object/hash encoding serializer.
function hash_serializer(result, key, value) {
    var matches = key.match(brackets);

    // Has brackets? Use the recursive assignment function to walk the keys,
    // construct any missing objects in the result tree and make the assignment
    // at the end of the chain.
    if (matches) {
        var keys = parse_keys(key);
        hash_assign(result, keys, value);
    }
    else {
        // Non bracket notation can make assignments directly.
        var existing = result[key];

        // If the value has been assigned already (for instance when a radio and
        // a checkbox have the same name attribute) convert the previous value
        // into an array before pushing into it.
        //
        // NOTE: If this requirement were removed all hash creation and
        // assignment could go through `hash_assign`.
        if (existing) {
            if (!Array.isArray(existing)) {
                result[key] = [ existing ];
            }

            result[key].push(value);
        }
        else {
            result[key] = value;
        }
    }

    return result;
}

// urlform encoding serializer
function str_serialize(result, key, value) {
    // encode newlines as \r\n cause the html spec says so
    value = value.replace(/(\r)?\n/g, '\r\n');
    value = encodeURIComponent(value);

    // spaces should be '+' rather than '%20'.
    value = value.replace(/%20/g, '+');
    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
}

module.exports = serialize;


/***/ },

/***/ 452
(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(452);
// EXTERNAL MODULE: ./src/js/modules/modalPolyfill.js
var modalPolyfill = __webpack_require__(560);
;// ./src/js/modules/getQuery.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getQuery = /*#__PURE__*/function () {
  function getQuery() {
    _classCallCheck(this, getQuery);
    this.params = [];
    this.init();
    this.getParam = this.getParam.bind(this);
    this.getAllParams = this.getAllParams.bind(this);
    this.buildQuery = this.buildQuery.bind(this);
  }
  return _createClass(getQuery, [{
    key: "init",
    value: function init() {
      this.getAllParams();
    }
  }, {
    key: "buildQuery",
    value: function buildQuery(params) {
      if (!params) params = this.getAllParams();
      return Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
      }).join('&').replace(/\+/g, '%20');
    }
  }, {
    key: "getAllParams",
    value: function getAllParams() {
      if (!location.search.length) return this.params;
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          this.params[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
      return this.params;
    }
  }, {
    key: "getParam",
    value: function getParam(paramId) {
      return this.params[paramId];
    }
  }]);
}();
/* harmony default export */ const modules_getQuery = (getQuery);
;// ./src/js/modules/submitSelect.js
function submitSelect_typeof(o) { "@babel/helpers - typeof"; return submitSelect_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, submitSelect_typeof(o); }
function submitSelect_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function submitSelect_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, submitSelect_toPropertyKey(o.key), o); } }
function submitSelect_createClass(e, r, t) { return r && submitSelect_defineProperties(e.prototype, r), t && submitSelect_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function submitSelect_toPropertyKey(t) { var i = submitSelect_toPrimitive(t, "string"); return "symbol" == submitSelect_typeof(i) ? i : i + ""; }
function submitSelect_toPrimitive(t, r) { if ("object" != submitSelect_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != submitSelect_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SubmitSelect = /*#__PURE__*/function () {
  function SubmitSelect(selector) {
    submitSelect_classCallCheck(this, SubmitSelect);
    this.s = selector;
    this.init();
  }
  return submitSelect_createClass(SubmitSelect, [{
    key: "onChange",
    value: function onChange(e) {
      e.preventDefault();
      var el = e.target;
      while ((el = el.parentElement) && !el.nodeName.toLowerCase() === 'form');
      el.submit();
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      document.querySelectorAll(this.s).forEach(function (el) {
        return el.addEventListener('change', _this.onChange);
      });
    }
  }]);
}();

;// ./src/js/codyhouse/index.js
// Utility function
function Util() {}
;

/*
	class manipulation functions
*/
Util.hasClass = function (el, className) {
  if (el.classList) return el.classList.contains(className);else return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};
Util.addClass = function (el, className) {
  var classList = className.split(' ');
  if (el.classList) el.classList.add(classList[0]);else if (!Util.hasClass(el, classList[0])) el.className += " " + classList[0];
  if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};
Util.removeClass = function (el, className) {
  var classList = className.split(' ');
  if (el.classList) el.classList.remove(classList[0]);else if (Util.hasClass(el, classList[0])) {
    var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
    el.className = el.className.replace(reg, ' ');
  }
  if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};
Util.toggleClass = function (el, className, bool) {
  if (bool) Util.addClass(el, className);else Util.removeClass(el, className);
};
Util.setAttributes = function (el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

/*
  DOM manipulation
*/
Util.getChildrenByClassName = function (el, className) {
  var children = el.children,
    childrenByClass = [];
  for (var i = 0; i < el.children.length; i++) {
    if (Util.hasClass(el.children[i], className)) childrenByClass.push(el.children[i]);
  }
  return childrenByClass;
};
Util.is = function (elem, selector) {
  if (selector.nodeType) {
    return elem === selector;
  }
  var qa = typeof selector === 'string' ? document.querySelectorAll(selector) : selector,
    length = qa.length,
    returnArr = [];
  while (length--) {
    if (qa[length] === elem) {
      return true;
    }
  }
  return false;
};

/*
	Animate height of an element
*/
Util.setHeight = function (start, to, element, duration, cb) {
  var change = to - start,
    currentTime = null;
  var _animateHeight = function animateHeight(timestamp) {
    if (!currentTime) currentTime = timestamp;
    var progress = timestamp - currentTime;
    var val = parseInt(progress / duration * change + start);
    element.style.height = val + "px";
    if (progress < duration) {
      window.requestAnimationFrame(_animateHeight);
    } else {
      cb();
    }
  };

  //set the height of the element before starting animation -> fix bug on Safari
  element.style.height = start + "px";
  window.requestAnimationFrame(_animateHeight);
};

/*
	Smooth Scroll
*/

Util.scrollTo = function (_final, duration, cb, scrollEl) {
  var element = scrollEl || window;
  var start = element.scrollTop || document.documentElement.scrollTop,
    currentTime = null;
  if (!scrollEl) start = window.scrollY || document.documentElement.scrollTop;
  var _animateScroll = function animateScroll(timestamp) {
    if (!currentTime) currentTime = timestamp;
    var progress = timestamp - currentTime;
    if (progress > duration) progress = duration;
    var val = Math.easeInOutQuad(progress, start, _final - start, duration);
    element.scrollTo(0, val);
    if (progress < duration) {
      window.requestAnimationFrame(_animateScroll);
    } else {
      cb && cb();
    }
  };
  window.requestAnimationFrame(_animateScroll);
};

/*
  Focus utility classes
*/

//Move focus to an element
Util.moveFocus = function (element) {
  if (!element) element = document.getElementsByTagName("body")[0];
  element.focus();
  if (document.activeElement !== element) {
    element.setAttribute('tabindex', '-1');
    element.focus();
  }
};

/*
  Misc
*/

Util.getIndexInArray = function (array, el) {
  return Array.prototype.indexOf.call(array, el);
};
Util.cssSupports = function (property, value) {
  if ('CSS' in window) {
    return CSS.supports(property, value);
  } else {
    var jsProperty = property.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    return jsProperty in document.body.style;
  }
};

// merge a set of user options into plugin defaults
// https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/
Util.extend = function () {
  // Variables
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length;

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0];
    i++;
  }

  // Merge the object into the extended object
  var merge = function merge(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Loop through each object and conduct a merge
  for (; i < length; i++) {
    var obj = arguments[i];
    merge(obj);
  }
  return extended;
};

// Check if Reduced Motion is enabled
Util.osHasReducedMotion = function () {
  if (!window.matchMedia) return false;
  var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (matchMediaObj) return matchMediaObj.matches;
  return false; // return false if not supported
};

/*
	Polyfills
*/
//Closest() method
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

//Custom Event() constructor
if (typeof window.CustomEvent !== "function") {
  var CustomEvent = function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
}

/*
	Animation curves
*/
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};
Math.easeInQuart = function (t, b, c, d) {
  t /= d;
  return c * t * t * t * t + b;
};
Math.easeOutQuart = function (t, b, c, d) {
  t /= d;
  t--;
  return -c * (t * t * t * t - 1) + b;
};
Math.easeInOutQuart = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t * t * t + b;
  t -= 2;
  return -c / 2 * (t * t * t * t - 2) + b;
};
Math.easeOutElastic = function (t, b, c, d) {
  var s = 1.70158;
  var p = d * 0.7;
  var a = c;
  if (t == 0) return b;
  if ((t /= d) == 1) return b + c;
  if (!p) p = d * .3;
  if (a < Math.abs(c)) {
    a = c;
    var s = p / 4;
  } else var s = p / (2 * Math.PI) * Math.asin(c / a);
  return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
};

/* JS Utility Classes */
(function () {
  // make focus ring visible only for keyboard navigation (i.e., tab key)
  var focusTab = document.getElementsByClassName('js-tab-focus');
  function detectClick() {
    if (focusTab.length > 0) {
      resetFocusTabs(false);
      window.addEventListener('keydown', detectTab);
    }
    window.removeEventListener('mousedown', detectClick);
  }
  ;
  function detectTab(event) {
    if (event.keyCode !== 9) return;
    resetFocusTabs(true);
    window.removeEventListener('keydown', detectTab);
    window.addEventListener('mousedown', detectClick);
  }
  ;
  function resetFocusTabs(bool) {
    var outlineStyle = bool ? '' : 'none';
    for (var i = 0; i < focusTab.length; i++) {
      focusTab[i].style.setProperty('outline', outlineStyle);
    }
  }
  ;
  window.addEventListener('mousedown', detectClick);
})();

;// ./src/js/modules/currency.js
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

var moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function currency_formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;
  function formatWithDelimiters(number) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
    var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(thousands));
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;// ./src/js/modules/utilities.js
function utilities_typeof(o) { "@babel/helpers - typeof"; return utilities_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, utilities_typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = utilities_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function utilities_toPropertyKey(t) { var i = utilities_toPrimitive(t, "string"); return "symbol" == utilities_typeof(i) ? i : i + ""; }
function utilities_toPrimitive(t, r) { if ("object" != utilities_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != utilities_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




(function () {
  var Moonbase = window.Moonbase || {};
  Moonbase.Utils = _objectSpread(_objectSpread({}, Util), {}, {
    Query: new modules_getQuery(),
    submitSelects: new SubmitSelect('[data-submit-select]'),
    addModule: function addModule(module, initFunction) {
      var Moonbase = window.Moonbase || {};
      Moonbase.modules = Moonbase.modules || {};
      Moonbase.modules[module] = initFunction;
    },
    buildLocaleURL: function buildLocaleURL(url) {
      var domain = "https://".concat(Moonbase.locale.domain);
      var extension = url.replace(domain, '').replace(/\//, '');
      return "".concat(domain).concat(window.Shopify.routes.root).concat(extension);
    },
    formatMoney: function formatMoney(price) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Moonbase.settings.moneyFormat;
      return currency_formatMoney(price, format);
    }
  });
})();
// EXTERNAL MODULE: ./src/js/modules/getTemplate.js
var getTemplate = __webpack_require__(220);
;// ./node_modules/micromodal/dist/micromodal.es.js
function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function t(e){return function(e){if(Array.isArray(e))return o(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return o(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return o(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var o=0,n=new Array(t);o<t;o++)n[o]=e[o];return n}var n,i,a,r,s,l=(n=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","[contenteditable]",'[tabindex]:not([tabindex^="-"])'],i=function(){function o(e){var n=e.targetModal,i=e.triggers,a=void 0===i?[]:i,r=e.onShow,s=void 0===r?function(){}:r,l=e.onClose,c=void 0===l?function(){}:l,d=e.openTrigger,u=void 0===d?"data-micromodal-trigger":d,f=e.closeTrigger,h=void 0===f?"data-micromodal-close":f,v=e.openClass,g=void 0===v?"is-open":v,m=e.disableScroll,b=void 0!==m&&m,y=e.disableFocus,p=void 0!==y&&y,w=e.awaitCloseAnimation,E=void 0!==w&&w,k=e.awaitOpenAnimation,M=void 0!==k&&k,A=e.debugMode,C=void 0!==A&&A;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,o),this.modal=document.getElementById(n),this.config={debugMode:C,disableScroll:b,openTrigger:u,closeTrigger:h,openClass:g,onShow:s,onClose:c,awaitCloseAnimation:E,awaitOpenAnimation:M,disableFocus:p},a.length>0&&this.registerTriggers.apply(this,t(a)),this.onClick=this.onClick.bind(this),this.onKeydown=this.onKeydown.bind(this)}var i,a,r;return i=o,(a=[{key:"registerTriggers",value:function(){for(var e=this,t=arguments.length,o=new Array(t),n=0;n<t;n++)o[n]=arguments[n];o.filter(Boolean).forEach((function(t){t.addEventListener("click",(function(t){return e.showModal(t)}))}))}},{key:"showModal",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(this.activeElement=document.activeElement,this.modal.setAttribute("aria-hidden","false"),this.modal.classList.add(this.config.openClass),this.scrollBehaviour("disable"),this.addEventListeners(),this.config.awaitOpenAnimation){var o=function t(){e.modal.removeEventListener("animationend",t,!1),e.setFocusToFirstNode()};this.modal.addEventListener("animationend",o,!1)}else this.setFocusToFirstNode();this.config.onShow(this.modal,this.activeElement,t)}},{key:"closeModal",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=this.modal;if(this.modal.setAttribute("aria-hidden","true"),this.removeEventListeners(),this.scrollBehaviour("enable"),this.activeElement&&this.activeElement.focus&&this.activeElement.focus(),this.config.onClose(this.modal,this.activeElement,e),this.config.awaitCloseAnimation){var o=this.config.openClass;this.modal.addEventListener("animationend",(function e(){t.classList.remove(o),t.removeEventListener("animationend",e,!1)}),!1)}else t.classList.remove(this.config.openClass)}},{key:"closeModalById",value:function(e){this.modal=document.getElementById(e),this.modal&&this.closeModal()}},{key:"scrollBehaviour",value:function(e){if(this.config.disableScroll){var t=document.querySelector("body");switch(e){case"enable":Object.assign(t.style,{overflow:""});break;case"disable":Object.assign(t.style,{overflow:"hidden"})}}}},{key:"addEventListeners",value:function(){this.modal.addEventListener("touchstart",this.onClick),this.modal.addEventListener("click",this.onClick),document.addEventListener("keydown",this.onKeydown)}},{key:"removeEventListeners",value:function(){this.modal.removeEventListener("touchstart",this.onClick),this.modal.removeEventListener("click",this.onClick),document.removeEventListener("keydown",this.onKeydown)}},{key:"onClick",value:function(e){(e.target.hasAttribute(this.config.closeTrigger)||e.target.parentNode.hasAttribute(this.config.closeTrigger))&&(e.preventDefault(),e.stopPropagation(),this.closeModal(e))}},{key:"onKeydown",value:function(e){27===e.keyCode&&this.closeModal(e),9===e.keyCode&&this.retainFocus(e)}},{key:"getFocusableNodes",value:function(){var e=this.modal.querySelectorAll(n);return Array.apply(void 0,t(e))}},{key:"setFocusToFirstNode",value:function(){var e=this;if(!this.config.disableFocus){var t=this.getFocusableNodes();if(0!==t.length){var o=t.filter((function(t){return!t.hasAttribute(e.config.closeTrigger)}));o.length>0&&o[0].focus(),0===o.length&&t[0].focus()}}}},{key:"retainFocus",value:function(e){var t=this.getFocusableNodes();if(0!==t.length)if(t=t.filter((function(e){return null!==e.offsetParent})),this.modal.contains(document.activeElement)){var o=t.indexOf(document.activeElement);e.shiftKey&&0===o&&(t[t.length-1].focus(),e.preventDefault()),!e.shiftKey&&t.length>0&&o===t.length-1&&(t[0].focus(),e.preventDefault())}else t[0].focus()}}])&&e(i.prototype,a),r&&e(i,r),o}(),a=null,r=function(e){if(!document.getElementById(e))return console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e,"'"),"background-color: #f8f9fa;color: #50596c;font-weight: bold;","ID somewhere in your code. Refer example below to resolve it."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<div class="modal" id="'.concat(e,'"></div>')),!1},s=function(e,t){if(function(e){e.length<=0&&(console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'","background-color: #f8f9fa;color: #50596c;font-weight: bold;","data attribute."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<a href="#" data-micromodal-trigger="my-modal"></a>'))}(e),!t)return!0;for(var o in t)r(o);return!0},{init:function(e){var o=Object.assign({},{openTrigger:"data-micromodal-trigger"},e),n=t(document.querySelectorAll("[".concat(o.openTrigger,"]"))),r=function(e,t){var o=[];return e.forEach((function(e){var n=e.attributes[t].value;void 0===o[n]&&(o[n]=[]),o[n].push(e)})),o}(n,o.openTrigger);if(!0!==o.debugMode||!1!==s(n,r))for(var l in r){var c=r[l];o.targetModal=l,o.triggers=t(c),a=new i(o)}},show:function(e,t){var o=t||{};o.targetModal=e,!0===o.debugMode&&!1===r(e)||(a&&a.removeEventListeners(),(a=new i(o)).showModal())},close:function(e){e?a.closeModalById(e):a.closeModal()}});"undefined"!=typeof window&&(window.MicroModal=l);/* harmony default export */ const micromodal_es = (l);

;// ./node_modules/whatwg-fetch/fetch.js
/* eslint-disable no-prototype-builtins */
var g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
  {}

var support = {
  searchParams: 'URLSearchParams' in g,
  iterable: 'Symbol' in g && 'iterator' in Symbol,
  blob:
    'FileReader' in g &&
    'Blob' in g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in g,
  arrayBuffer: 'ArrayBuffer' in g
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 200, statusText: ''})
  response.ok = false
  response.status = 0
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = g.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch_fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && g.location.href ? g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name))
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch_fetch.polyfill = true

if (!g.fetch) {
  g.fetch = fetch_fetch
  g.Headers = Headers
  g.Request = Request
  g.Response = Response
}

// EXTERNAL MODULE: ./node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(76);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
;// ./src/js/modules/GoCart.js
function GoCart_typeof(o) { "@babel/helpers - typeof"; return GoCart_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, GoCart_typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function GoCart_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function GoCart_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, GoCart_toPropertyKey(o.key), o); } }
function GoCart_createClass(e, r, t) { return r && GoCart_defineProperties(e.prototype, r), t && GoCart_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function GoCart_toPropertyKey(t) { var i = GoCart_toPrimitive(t, "string"); return "symbol" == GoCart_typeof(i) ? i : i + ""; }
function GoCart_toPrimitive(t, r) { if ("object" != GoCart_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != GoCart_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var GoCart = /*#__PURE__*/function () {
  function GoCart(options) {
    GoCart_classCallCheck(this, GoCart);
    var defaults = {
      cartModalFail: '.js-go-cart-modal-fail',
      cartModalFailClose: '.js-go-cart-modal-fail-close',
      cartModal: '.js-go-cart-modal',
      cartModalClose: '.js-go-cart-modal-close',
      cartModalContent: '.js-go-cart-modal-content',
      cartDrawer: '.js-go-cart-drawer',
      cartDrawerContent: '.js-go-cart-drawer-content',
      cartDrawerOfferMessages: '.js-go-cart-drawer-offer-messages',
      cartDrawerWelcomeOffer: '.js-go-cart-drawer-welcome-offer',
      cartDrawerOfferThresholds: '.js-go-cart-drawer-offer-thresholds',
      cartDrawerOfferThreshold: '.js-go-cart-drawer-offer-threshold',
      cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
      cartDrawerTotalDiscount: '.js-go-cart-drawer-total-discount',
      cartDrawerTotalPoints: '.js-go-cart-drawer-total-points',
      cartDrawerShippingNotice: '.js-shipping-notice',
      cartDrawerFooter: '.js-go-cart-drawer-footer',
      cartDrawerClose: '.js-go-cart-drawer-close',
      cartMiniCart: '.js-go-cart-mini-cart',
      cartMiniCartContent: '.js-go-cart-mini-cart-content',
      cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
      cartMiniCartShippingNotice: '.js-mini-cart-shipping-notice',
      cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
      cartMiniCartClose: '.js-go-cart-mini-cart-close',
      cartTrigger: '.js-go-cart-trigger',
      cartOverlay: '.js-go-cart-overlay',
      cartCount: '.js-go-cart-counter',
      addToCart: '.js-go-cart-add-to-cart',
      removeFromCart: '.js-go-cart-remove-from-cart',
      removeFromCartNoDot: 'js-go-cart-remove-from-cart',
      itemQuantity: '.js-go-cart-quantity',
      itemQuantityPlus: '.js-go-cart-quantity-plus',
      itemQuantityMinus: '.js-go-cart-quantity-minus',
      cartMode: 'drawer',
      drawerDirection: 'right',
      displayModal: false,
      moneyFormat: '${{amount}}',
      totalDiscount: 0,
      totalPoints: 0
    };
    this.defaults = Object.assign({}, defaults, options);
    this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
    this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
    this.cartModal = document.querySelector(this.defaults.cartModal);
    this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
    this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
    this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
    this.cartDrawerOfferMessages = document.querySelector(this.defaults.cartDrawerOfferMessages);
    this.cartDrawerWelcomeOffer = document.querySelector(this.defaults.cartDrawerWelcomeOffer);
    this.cartDrawerOfferThresholds = document.querySelector(this.defaults.cartDrawerOfferThresholds);
    this.cartDrawerOfferThreshold = document.querySelectorAll(this.defaults.cartDrawerOfferThreshold);
    this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
    this.cartDrawerTotalDiscount = document.querySelector(this.defaults.cartDrawerTotalDiscount);
    this.cartDrawerTotalPoints = document.querySelector(this.defaults.cartDrawerTotalPoints);
    this.cartDrawerShippingNotice = document.querySelector(this.defaults.cartDrawerShippingNotice);
    this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
    this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
    this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
    this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
    this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
    this.cartMiniCartShippingNotice = document.querySelector(this.defaults.cartMiniCartShippingNotice);
    this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
    this.cartMiniCartClose = document.querySelector(this.defaults.cartMiniCartClose);
    this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
    this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
    this.cartCount = document.querySelector(this.defaults.cartCount);
    this.addToCart = document.querySelectorAll(this.defaults.addToCart);
    this.removeFromCart = this.defaults.removeFromCart;
    this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
    this.itemQuantity = this.defaults.itemQuantity;
    this.itemQuantityPlus = this.defaults.itemQuantityPlus;
    this.itemQuantityMinus = this.defaults.itemQuantityMinus;
    this.cartMode = this.defaults.cartMode;
    this.drawerDirection = this.defaults.drawerDirection;
    this.displayModal = this.defaults.displayModal;
    this.moneyFormat = this.defaults.moneyFormat;
    this.totalDiscount = this.defaults.totalDiscount;
    this.totalPoints = this.defaults.totalPoints;
    this.initAddToCarts = this.initAddToCarts.bind(this);
    this.init();
  }
  return GoCart_createClass(GoCart, [{
    key: "isDrawerMode",
    get: function get() {
      return this.cartMode === 'drawer';
    }
  }, {
    key: "initAddToCarts",
    value: function initAddToCarts() {
      var _this = this;
      var els = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.addToCart;
      els && els.forEach(function (item) {
        item.addEventListener('click', function (event) {
          event.preventDefault();
          var formID = item.closest('form').getAttribute('id');
          _this.addItemToCart(formID);
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      this.fetchCart();
      if (this.isDrawerMode) {
        this.setDrawerDirection();
      }
      this.initAddToCarts();
      this.cartTrigger.length > 0 && this.cartTrigger.forEach(function (el) {
        return el.addEventListener('click', function () {
          if (_this2.isDrawerMode) {
            _this2.openCartDrawer();
          } else {
            _this2.openMiniCart();
          }
          _this2.openCartOverlay();
        });
      });
      this.cartOverlay && this.cartOverlay.addEventListener('click', function () {
        _this2.closeFailModal();
        _this2.closeCartModal();
        if (_this2.isDrawerMode) {
          _this2.closeCartDrawer();
        } else {
          _this2.closeMiniCart();
        }
        _this2.closeCartOverlay();
      });
      this.cartMiniCartClose && this.cartMiniCartClose.addEventListener('click', function () {
        _this2.closeMiniCart();
        _this2.closeCartOverlay();
      });
      if (this.isDrawerMode) {
        this.cartDrawerClose && this.cartDrawerClose.addEventListener('click', function () {
          _this2.closeCartDrawer();
          _this2.closeCartOverlay();
        });
      }
      if (this.displayModal) {
        this.cartModalClose.length > 0 && this.cartModalClose.forEach(function (item) {
          item.addEventListener('click', function () {
            _this2.closeFailModal();
            _this2.closeCartModal();
            if (_this2.isDrawerMode) {
              _this2.closeCartDrawer();
            } else {
              _this2.closeMiniCart();
            }
            _this2.closeCartOverlay();
          });
        });
      }
      this.cartModalFailClose && this.cartModalFailClose.addEventListener('click', function () {
        _this2.closeFailModal();
        _this2.closeCartModal();
        if (_this2.isDrawerMode) {
          _this2.closeCartDrawer();
        } else {
          _this2.closeMiniCart();
        }
        _this2.closeCartOverlay();
      });
      this.initQuickAddSelectors();
    }
  }, {
    key: "fetchCart",
    value: function fetchCart(callback, cart) {
      var _this3 = this;
      if (cart) {
        this.addExtraCartData(cart, callback);
      } else {
        window.fetch(Moonbase.Utils.buildLocaleURL('/cart.js'), {
          method: 'GET'
        }).then(function (response) {
          return response.json();
        }).then(function (cart) {
          _this3.addExtraCartData(cart, callback);
        })["catch"](function (error) {
          _this3.ajaxRequestFail();
          throw new Error(error);
        });
      }
    }
  }, {
    key: "addExtraCartData",
    value: function addExtraCartData(cart, callback) {
      var cartItems = cart.items;
      cartItems.length > 0 && cartItems.forEach(function (item) {
        $.ajax({
          url: '/products/' + item.handle + '.js',
          dataType: 'json',
          async: false,
          success: function success(product) {
            var productVariants = product.variants;
            var productTags = product.tags;
            productVariants.length > 0 && productVariants.forEach(function (variant) {
              if (variant.compare_at_price != null && variant.id == item.variant_id) item["compare_at_price"] = variant.compare_at_price;else item["compare_at_price"] = 0;
            });
            item["product_tags"] = productTags;
          }
        });
      });
      var cartTotalWithoutBundlesAndSubs = 0;
      cartItems.length > 0 && cartItems.forEach(function (item) {
        if (!item.product_title.includes("ZPOS") && !item.product_title.includes("Bundle") && !item.selling_plan_allocation) {
          cartTotalWithoutBundlesAndSubs = cartTotalWithoutBundlesAndSubs + item.original_line_price;
        }
      });
      cart.total_without_bundles_and_subs = cartTotalWithoutBundlesAndSubs;
      this.fetchHandler(cart, callback);
    }
  }, {
    key: "toggleAddToCartLoading",
    value: function toggleAddToCartLoading(container) {
      var _this4 = this;
      this.isLoading = !this.isLoading;
      this.addToCart.length > 0 && this.addToCart.forEach(function (el) {
        if (container && !container.contains(el)) return;
        if (container) {
          if (!container.contains(el)) return;
          var _el$dataset = el.dataset,
            labelAddToCart = _el$dataset.labelAddToCart,
            _labelAddToCartLoading = _el$dataset.labelAddToCartLoading;
          if (_this4.isLoading) {
            el.innerHTML = _labelAddToCartLoading;
            el.classList.add('is-loading');
          } else {
            el.innerHTML = labelAddToCart;
          }
        } else {
          if (_this4.isLoading) {
            el.innerHTML = labelAddToCartLoading;
            el.classList.add('is-loading');
          } else {
            Moonbase.product.updateAddToCartButton();
          }
        }
        el.classList.remove('is-loading');
      });
    }
  }, {
    key: "addItemToCart",
    value: function addItemToCart(formID) {
      var _this5 = this;
      var form = document.querySelector("#".concat(formID));
      var formData = form_serialize_default()(form, {
        hash: true
      });
      var productId = form.dataset.product;
      var container = null;
      if (!Moonbase.product || Moonbase.product.product.id !== productId) {
        container = form;
      }
      var selectedSellingPlan = document.querySelector('.selected-selling-plan-id');
      if (selectedSellingPlan) {
        var errorMessage = document.querySelector('.product-selling-plan__dropdown-error');
        if (errorMessage) {
          if ((formData === null || formData === void 0 ? void 0 : formData.selling_plan) === 'no_plan_selected') {
            errorMessage.classList.add('product-selling-plan__dropdown-error--active');
            return;
          } else {
            errorMessage.classList.remove('product-selling-plan__dropdown-error--active');
          }
        }
      }
      this.toggleAddToCartLoading(container);
      window.fetch(Moonbase.Utils.buildLocaleURL('/cart/add.js'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        return response.json();
      }).then(function (product) {
        return _this5.addItemToCartHandler(product, container);
      })["catch"](function (error) {
        _this5.ajaxRequestFail();
        _this5.toggleAddToCartLoading();
        throw new Error(error);
      });
    }
  }, {
    key: "removeItem",
    value: function removeItem(line) {
      var _this6 = this;
      var quantity = 0;
      window.fetch(Moonbase.Utils.buildLocaleURL('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({
          quantity: quantity,
          line: line
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        return _this6.fetchCart(null, cart);
      })["catch"](function (error) {
        _this6.ajaxRequestFail();
        throw new Error(error);
      });
    }
  }, {
    key: "changeItemQuantity",
    value: function changeItemQuantity(line, quantity) {
      var _this7 = this;
      window.fetch(Moonbase.Utils.buildLocaleURL('/cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({
          quantity: quantity,
          line: line
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        return _this7.fetchCart(null, cart);
      })["catch"](function (error) {
        _this7.ajaxRequestFail();
        throw new Error(error);
      });
    }
  }, {
    key: "cartItemCount",
    value: function cartItemCount(cart) {
      this.cartCount.innerHTML = cart.item_count;
    }
  }, {
    key: "fetchAndOpenCart",
    value: function fetchAndOpenCart() {
      var _this8 = this;
      this.fetchCart(function () {
        if (_this8.isDrawerMode) {
          _this8.openCartDrawer();
        } else {
          _this8.openMiniCart();
        }
        _this8.openCartOverlay();
      });
    }
  }, {
    key: "fetchAndOpenModal",
    value: function fetchAndOpenModal(product) {
      var _this9 = this;
      this.fetchCart(function () {
        _this9.renderCartModal(product);
        _this9.openCartModal();
        _this9.openCartOverlay();
      });
    }
  }, {
    key: "fetchHandler",
    value: function fetchHandler(cart, callback) {
      //Handler Changes
      if (Moonbase.template === 'cart' && Moonbase.cart && Moonbase.cart.updateCart) {
        Moonbase.cart.updateCart(cart);
      }
      this.cartItemCount(cart);
      if (this.isDrawerMode) {
        if (cart.item_count === 0) {
          this.renderBlankCartDrawer();
          this.cartDrawerFooter && this.cartDrawerFooter.classList.add('is-invisible');
        } else {
          this.renderDrawerCart(cart);
          this.cartDrawerFooter && this.cartDrawerFooter.classList.remove('is-invisible');
          if (typeof callback === 'function') {
            callback(cart);
          }
          this.getRecommended();
        }
      } else if (cart.item_count === 0) {
        this.renderBlankMiniCart();
        this.cartMiniCartFooter && this.cartMiniCartFooter.classList.add('is-invisible');
      } else {
        this.renderMiniCart(cart);
        this.cartMiniCartFooter && this.cartMiniCartFooter.classList.remove('is-invisible');
        if (typeof callback === 'function') {
          callback(cart);
        }
      }
    }
  }, {
    key: "addItemToCartHandler",
    value: function addItemToCartHandler(product, container) {
      this.toggleAddToCartLoading(container);
      return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
    }
  }, {
    key: "ajaxRequestFail",
    value: function ajaxRequestFail() {
      this.openFailModal();
      this.openCartOverlay();
    }
  }, {
    key: "waitForVar",
    value: function waitForVar(variable, callback) {
      if (typeof variable !== 'undefined') {
        if (typeof callback === 'function') setTimeout(function () {
          callback();
        }, 500);
      } else {
        setTimeout(function () {
          this.waitForVar(variable, callback);
        }, 250);
      }
    }
  }, {
    key: "updatePoints",
    value: function updatePoints(cart) {
      var drawerTotalPoints = document.querySelector('.js-go-cart-drawer-total-points');
      if (!drawerTotalPoints) return;
      // TODO: For Yotpo Loyalty
      drawerTotalPoints.parentNode.classList.remove('is-invisible');
    }
  }, {
    key: "renderCartModal",
    value: function renderCartModal(product) {
      this.clearCartModal();
      var productVariant = product.variant_title;
      if (productVariant === null) {
        productVariant = '';
      } else {
        productVariant = "(".concat(productVariant, ")");
      }
      var feedbackTitle = productVariant ? product.product_title + ' ' + productVariant : product.product_title;
      var cartFeedbackMessage = '#title# added.'.replace('#title#', feedbackTitle).replace('#link#', product.url);
      var cartSingleProduct = "\n        <div class=\"flex margin-bottom-sm\">\n            <div class=\"go-cart-modal-item__image flex-shrink-0\" style=\"background-image: url(".concat(product.image, ");\"></div>\n            <div class=\"go-cart-modal-item__info padding-left-md text-left\">\n                <p>").concat(cartFeedbackMessage, "</p>\n            </div>\n        </div>\n      ");
      this.cartModalContent.innerHTML += cartSingleProduct;
    }
  }, {
    key: "updateCartOfferMessaging",
    value: function updateCartOfferMessaging(cart) {
      var _this0 = this;
      var offerMessages = this.cartDrawerOfferMessages;
      var welcomeOffer = this.cartDrawerWelcomeOffer;
      var offerThresholds = this.cartDrawerOfferThresholds;
      var hasSubscription = Array.isArray(cart.items) && cart.items.some(function (item) {
        return item.selling_plan_allocation;
      });
      var isNewCustomer = (offerMessages === null || offerMessages === void 0 ? void 0 : offerMessages.dataset.isNewCustomer) === 'true';
      if (welcomeOffer) {
        welcomeOffer.classList.add('is-hidden');
      }
      if (offerThresholds) {
        offerThresholds.classList.add('is-hidden');
      }
      if (offerMessages) {
        offerMessages.classList.add('is-hidden');
      }
      this.cartDrawerOfferThreshold.length > 0 && this.cartDrawerOfferThreshold.forEach(function (offer) {
        offer.classList.add('is-hidden');
      });
      if (hasSubscription) {
        return;
      }
      if (isNewCustomer) {
        if (welcomeOffer) {
          welcomeOffer.classList.remove('is-hidden');
        }
        if (offerMessages) {
          offerMessages.classList.remove('is-hidden');
        }
        return;
      }
      if (this.cartDrawerOfferThreshold.length === 0) {
        return;
      }
      var offerRendered = false;
      this.cartDrawerOfferThreshold.forEach(function (offer) {
        var offerThreshold = Number(offer.dataset.offerThreshold);
        var cartTotal = 0;
        if (offer.dataset.offerExclusionsApply === 'false') {
          cartTotal = Number(cart.original_total_price);
        } else {
          cartTotal = Number(cart.total_without_bundles_and_subs);
        }
        var spend = currency_formatMoney(offer.dataset.offerThreshold - cartTotal, _this0.moneyFormat);
        var newInnerHTML = offer.dataset.offerThresholdMessage;
        offer.innerHTML = newInnerHTML.replace('AMOUNT', spend);
        if (offerThreshold >= cartTotal && offerRendered === false) {
          offer.classList.remove('is-hidden');
          offerRendered = true;
        }
      });
      if (offerRendered === true) {
        if (offerThresholds) {
          offerThresholds.classList.remove('is-hidden');
        }
        if (offerMessages) {
          offerMessages.classList.remove('is-hidden');
        }
      }
    }
  }, {
    key: "renderDrawerCart",
    value: function renderDrawerCart(cart) {
      var _this1 = this,
        _this$cartDrawerTotal;
      this.clearCartDrawer();
      this.totalDiscount = 0;
      var cartItems = cart.items;
      cartItems.length > 0 && cartItems.forEach(function (item, index) {
        var itemVariant = item.variant_title;
        if (itemVariant === null) {
          itemVariant = '';
        }
        var itemSubscription = '';
        if (item.selling_plan_allocation !== undefined) {
          itemSubscription = item.selling_plan_allocation.selling_plan.name;
        }
        var price = '';
        var isDiscount = false;
        var compareAtPrice = item.compare_at_price * item.quantity;
        if (compareAtPrice > 0) {
          price = "\n          <s>".concat(currency_formatMoney(compareAtPrice, _this1.moneyFormat), "</s>\n          ").concat(currency_formatMoney(item.final_line_price, _this1.moneyFormat), "\n        ");
          var compareAtPriceDiff = compareAtPrice - item.original_line_price;
          _this1.totalDiscount += compareAtPriceDiff;
          isDiscount = true;
        } else {
          price = "".concat(currency_formatMoney(item.final_line_price, _this1.moneyFormat));
        }
        if (item.final_line_price < item.original_line_price) {
          var mostOriginalPrice = item.original_line_price;
          if (compareAtPrice > 0) {
            mostOriginalPrice = compareAtPrice;
          }
          price = "\n          <s>".concat(currency_formatMoney(mostOriginalPrice, _this1.moneyFormat), "</s>\n          ").concat(currency_formatMoney(item.final_line_price, _this1.moneyFormat), "\n        ");
          isDiscount = true;
        }
        var discountArray = item.discounts;
        var discountTitle = discountArray.map(function (element) {
          return element.title;
        });
        var discount = '';
        if (item.discounts.length > 0) {
          discount = discountTitle.join(', ');
        }
        var cartSingleProduct = "\n        <div class=\"go-cart-item__single padding-y-md width-100%\" data-line=\"".concat(Number(index + 1), "\">\n            <div class=\"flex\">\n                <div class=\"go-cart-item__image flex-shrink-0\" style=\"background-image: url(").concat(item.image, ");\"></div>\n                <div class=\"go-cart-item__info flex-grow padding-left-xs\">\n                  ").concat(_this1.renderProductTitle(item), "\n                  <div class=\"text-sm width-100% margin-bottom-xxs\">\n                    ").concat(itemVariant, "\n                  </div>\n                  <div class=\"text-sm width-100% margin-bottom-xxs\">\n                    ").concat(itemSubscription, "\n                  </div>\n                  <div class=\"flex flex-wrap items-center justify-between\">\n                    <a class=\"go-cart-item__remove margin-top-xxs ").concat(_this1.removeFromCartNoDot, "\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" width=\"16px\"><path d=\"m170.5 51.6-19 28.4h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6h-93.7c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6 36.7 55H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v304c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h69.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128v304c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V128H80zm80 64v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z\"/></svg>\n                    </a>\n                    <div class=\"col-6 flex items-center margin-bottom-xs\">\n                      <a href=\"javascript:void(0)\" class=\"go-cart-item__quantity-button js-go-cart-quantity-minus form-control form-control--left width-lg\" tabindex=\"0\">-</a>\n                      <input class=\"go-cart-item__quantity-number js-go-cart-quantity form-control form-control--center width-lg\" type=\"number\" value=\"").concat(item.quantity, "\" disabled>\n                      <a href=\"javascript:void(0)\" class=\"go-cart-item__quantity-button js-go-cart-quantity-plus form-control form-control--right width-lg\" tabindex=\"0\">+</a>\n                    </div>\n                    <div class=\"col-4 text-right font-bold go-cart-item__price ").concat(isDiscount ? '-discount' : '', "\">\n                      ").concat(price, "\n                    </div>\n                    <div class=\"col-12 text-sm margin-top-xxs js-cart-discount\">").concat(discount, "</div>\n                  </div>\n                </div>\n            </div>\n        </div>\n      ");
        _this1.cartDrawerContent.innerHTML += cartSingleProduct;
      });
      this.cartDrawerContent.innerHTML += '<div id="sideCartRecommendedMobile"></div>';
      var totalDiscount = cart.total_discount;
      this.totalDiscount += totalDiscount;
      this.updateCartOfferMessaging(cart);
      var perRewardPoints = Number((_this$cartDrawerTotal = this.cartDrawerTotalPoints.dataset.currencyPerRewardPoint) !== null && _this$cartDrawerTotal !== void 0 ? _this$cartDrawerTotal : 0);
      var totalPoints = Math.floor(Number(cart.total_price) / 100) * perRewardPoints;
      this.totalPoints = totalPoints;
      this.cartDrawerSubTotal.innerHTML = currency_formatMoney(cart.total_price, this.moneyFormat);
      this.cartDrawerTotalDiscount.innerHTML = currency_formatMoney(this.totalDiscount, this.moneyFormat);
      this.cartDrawerTotalPoints.innerHTML = this.totalPoints;
      this.cartDrawerSubTotal && this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
      this.cartDrawerTotalDiscount && this.cartDrawerTotalDiscount.parentNode.classList.remove('is-invisible');
      this.cartDrawerTotalPoints && this.cartDrawerTotalPoints.parentNode.classList.remove('is-invisible');
      this.cartDrawerShippingNotice && this.cartDrawerShippingNotice.classList.remove('is-invisible');
      var removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.length > 0 && removeFromCart.forEach(function (item) {
        item.addEventListener('click', function () {
          GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
          var line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          _this1.removeItem(line);
        });
      });
      var itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.length > 0 && itemQuantityPlus.forEach(function (item) {
        item.addEventListener('click', function () {
          var line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          var quantity = Number(item.parentNode.querySelector(_this1.itemQuantity).value) + 1;
          _this1.changeItemQuantity(line, quantity);
        });
      });
      var itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.length > 0 && itemQuantityMinus.forEach(function (item) {
        item.addEventListener('click', function () {
          var line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          var quantity = Number(item.parentNode.querySelector(_this1.itemQuantity).value) - 1;
          _this1.changeItemQuantity(line, quantity);
          if (Number(item.parentNode.querySelector(_this1.itemQuantity).value - 1) === 0) {
            GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
          }
        });
      });
    }
  }, {
    key: "renderMiniCart",
    value: function renderMiniCart(cart) {
      var _this10 = this;
      this.clearMiniCart();
      var cartItems = cart.items;
      cartItems.length > 0 && cartItems.forEach(function (item, index) {
        var itemVariant = item.variant_title;
        if (itemVariant === null) {
          itemVariant = '';
        }
        var cartSingleProduct = "\n            <div class=\"go-cart-item__single padding-y-md width-100%\" data-line=\"".concat(Number(index + 1), "\">\n                <div class=\"flex\">\n                    <div class=\"go-cart-item__image flex-shrink-0\" style=\"background-image: url(").concat(item.image, ");\"></div>\n                    <div class=\"go-cart-item__info flex-grow padding-left-xs\">\n                      ").concat(_this10.renderProductTitle(item), "\n                      <div class=\"text-sm width-100% margin-bottom-xxs\">\n                        ").concat(itemVariant, "\n                      </div>\n\n                      <div class=\"flex flex-wrap items-center justify-between margin-bottom-xs\">\n                        <div class=\"col-6 flex items-center\">\n                          <a href=\"javascript:void(0)\" class=\"go-cart-item__quantity-button js-go-cart-quantity-minus form-control form-control--left width-lg\" tabindex=\"0\">-</a>\n                          <input class=\"go-cart-item__quantity-number js-go-cart-quantity form-control form-control--center width-xl\" type=\"number\" value=\"").concat(item.quantity, "\" disabled>\n                          <a href=\"javascript:void(0)\" class=\"go-cart-item__quantity-button js-go-cart-quantity-plus form-control form-control--right width-lg\" tabindex=\"0\">+</a>\n                        </div>\n                        <div class=\"col-6 font-bold text-right go-cart-item__price go-cart-item__price\">\n                          ").concat(currency_formatMoney(item.line_price, _this10.moneyFormat), "\n                        </div>\n                        <a href=\"javascript:void(0)\" class=\"margin-top-sm go-cart-item__remove ").concat(_this10.removeFromCartNoDot, "\" tabindex=\"0\">Remove</a>\n                      </div>\n\n\n                    </div>\n                </div>\n            </div>\n      ");
        _this10.cartMiniCartContent.innerHTML += cartSingleProduct;
      });
      this.cartMiniCartSubTotal.innerHTML = currency_formatMoney(cart.total_price, this.moneyFormat);
      this.cartMiniCartSubTotal && this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
      this.cartDrawerTotalDiscount && this.cartDrawerTotalDiscount.parentNode.classList.remove('is-invisible');
      this.cartMiniCartShippingNotice && this.cartMiniCartShippingNotice.classList.remove('is-invisible');
      var removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.length > 0 && removeFromCart.forEach(function (item) {
        item.addEventListener('click', function () {
          GoCart.removeItemAnimation(item.parentNode);
          var line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          _this10.removeItem(line);
        });
      });
      var itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.length > 0 && itemQuantityPlus.forEach(function (item) {
        item.addEventListener('click', function () {
          var line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          var quantity = Number(item.parentNode.querySelector(_this10.itemQuantity).value) + 1;
          _this10.changeItemQuantity(line, quantity);
        });
      });
      var itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.length > 0 && itemQuantityMinus.forEach(function (item) {
        item.addEventListener('click', function () {
          var line = item.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
          var quantity = Number(item.parentNode.querySelector(_this10.itemQuantity).value) - 1;
          _this10.changeItemQuantity(line, quantity);
          if (Number(item.parentNode.querySelector(_this10.itemQuantity).value - 1) === 0) {
            GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode.parentNode);
          }
        });
      });
    }
  }, {
    key: "renderProductTitle",
    value: function renderProductTitle(product) {
      var product_url = product.url;
      if (product_url.startsWith('/product')) {
        // Despite a request including a locale, Shopify doesn't return the product URL with a locale when a cart item is changed
        product_url = Moonbase.Utils.buildLocaleURL(product_url);
      }
      return "<a href=\"".concat(product_url, "\" class=\"go-cart-item__title width-100% font-bold block margin-bottom-xxs\">\n      ").concat(product.product_title, "\n    </a>");
    }
  }, {
    key: "renderBlankCartDrawer",
    value: function renderBlankCartDrawer() {
      this.cartDrawerSubTotal && this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
      this.cartDrawerTotalDiscount && this.cartDrawerTotalDiscount.parentNode.classList.add('is-invisible');
      this.cartDrawerTotalPoints && this.cartDrawerTotalPoints.parentNode.classList.add('is-invisible');
      this.cartDrawerOfferThreshold[0] && this.cartDrawerOfferThreshold[0].parentElement.classList.add('is-hidden');
      this.cartDrawerShippingNotice && this.cartDrawerShippingNotice.classList.add('is-invisible');
      this.clearCartDrawer();
      this.cartDrawerContent.innerHTML = '<div class="go-cart__empty">Your Bag is currently empty!</div>';
    }
  }, {
    key: "renderBlankMiniCart",
    value: function renderBlankMiniCart() {
      this.cartDrawerTotalDiscount && this.cartDrawerTotalDiscount.parentNode.classList.add('is-invisible');
      this.cartMiniCartSubTotal && this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
      this.cartMiniCartShippingNotice && this.cartMiniCartShippingNotice.classList.add('is-invisible');
      this.cartDrawerOfferThreshold[0] && this.cartDrawerOfferThreshold[0].parentElement.classList.add('is-hidden');
      this.clearMiniCart();
      this.cartMiniCartContent.innerHTML = '<div class="go-cart__empty">Your Bag is currently empty!</div>';
    }
  }, {
    key: "getRecommended",
    value: function getRecommended() {
      var recommendedContent = '';
      var recommendedContainer = document.getElementById('sideCartRecommended');
      var recommendedContainerMobile = document.getElementById('sideCartRecommendedMobile');
      try {
        var loadRecommended = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url) {
            var response, data;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return fetch(url);
                case 1:
                  response = _context.v;
                  _context.n = 2;
                  return response.text();
                case 2:
                  data = _context.v;
                  recommendedContent = data;
                  recommendedContainer.innerHTML = recommendedContent;
                  recommendedContainerMobile.innerHTML = recommendedContent;
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function loadRecommended(_x) {
            return _ref.apply(this, arguments);
          };
        }();
        loadRecommended('/cart?view=recommended');
      } catch (err) {
        console.error("Loading cart recommendations failed: " + err);
      }
    }
  }, {
    key: "clearCartDrawer",
    value: function clearCartDrawer() {
      this.cartDrawerContent.innerHTML = '';
    }
  }, {
    key: "clearMiniCart",
    value: function clearMiniCart() {
      this.cartMiniCartContent.innerHTML = '';
    }
  }, {
    key: "clearCartModal",
    value: function clearCartModal() {
      this.cartModalContent.innerHTML = '';
    }
  }, {
    key: "openCartDrawer",
    value: function openCartDrawer() {
      document.body.classList.add('no-scroll');
      this.cartDrawer && this.cartDrawer.classList.add('is-open');
    }
  }, {
    key: "closeCartDrawer",
    value: function closeCartDrawer() {
      document.body.classList.remove('no-scroll');
      this.cartDrawer && this.cartDrawer.classList.remove('is-open');
    }
  }, {
    key: "openMiniCart",
    value: function openMiniCart() {
      this.cartMiniCart && this.cartMiniCart.classList.add('is-open');
    }
  }, {
    key: "closeMiniCart",
    value: function closeMiniCart() {
      this.cartMiniCart && this.cartMiniCart.classList.remove('is-open');
    }
  }, {
    key: "openFailModal",
    value: function openFailModal() {
      this.cartModalFail && this.cartModalFail.classList.add('is-open');
    }
  }, {
    key: "closeFailModal",
    value: function closeFailModal() {
      this.cartModalFail && this.cartModalFail.classList.remove('is-open');
    }
  }, {
    key: "openCartModal",
    value: function openCartModal() {
      this.cartModal && this.cartModal.classList.add('is-open');
    }
  }, {
    key: "closeCartModal",
    value: function closeCartModal() {
      this.cartModal && this.cartModal.classList.remove('is-open');
    }
  }, {
    key: "openCartOverlay",
    value: function openCartOverlay() {
      this.cartOverlay && this.cartOverlay.classList.add('is-open');
    }
  }, {
    key: "closeCartOverlay",
    value: function closeCartOverlay() {
      this.cartOverlay && this.cartOverlay.classList.remove('is-open');
    }
  }, {
    key: "setDrawerDirection",
    value: function setDrawerDirection() {
      this.cartDrawer && this.cartDrawer.classList.add("go-cart__drawer--".concat(this.drawerDirection));
    }
  }, {
    key: "initQuickAddSelectors",
    value: function initQuickAddSelectors() {
      var quickAddVariantSelector = document.querySelectorAll('.js-quick-add-variant-selector');
      quickAddVariantSelector.length > 0 && quickAddVariantSelector.forEach(function (el) {
        el.addEventListener('change', function (e) {
          var selected = e.target.options[e.target.options.selectedIndex];
          var parent = e.target.closest('.product-card');
          if (parent) {
            var price = parent.querySelector('.price');
            if (price) price.innerHTML = Moonbase.Utils.formatMoney(selected.dataset.price * 100);
          }
          document.querySelector('.js-' + e.target.dataset.productId + '-variant').value = e.target.value;
        });
      });
    }
  }], [{
    key: "removeItemAnimation",
    value: function removeItemAnimation(item) {
      if (!item) return;
      item.classList.add('is-invisible');
    }
  }]);
}();
/* harmony default export */ const modules_GoCart = (GoCart);
;// ./src/js/modules/expandables.js
function expandables_typeof(o) { "@babel/helpers - typeof"; return expandables_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, expandables_typeof(o); }
function expandables_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function expandables_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, expandables_toPropertyKey(o.key), o); } }
function expandables_createClass(e, r, t) { return r && expandables_defineProperties(e.prototype, r), t && expandables_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function expandables_toPropertyKey(t) { var i = expandables_toPrimitive(t, "string"); return "symbol" == expandables_typeof(i) ? i : i + ""; }
function expandables_toPrimitive(t, r) { if ("object" != expandables_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != expandables_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Expandable = /*#__PURE__*/function () {
  function Expandable(options) {
    expandables_classCallCheck(this, Expandable);
    this.container = options.container;
    this.isOpen = options.isOpen || false;
    this.toggle = this.toggle.bind(this);
  }
  return expandables_createClass(Expandable, [{
    key: "init",
    value: function init() {
      this.wrap = this.container.querySelector('[data-expandable-wrap]');
      this.button = this.container.querySelector('[data-expandable-toggle]');
      if (!this.wrap || !this.toggle) {
        console.log('Expandable unable to initialise', this.container);
      } else {
        this.button.addEventListener('click', this.toggle);
        this.wrap.classList.add('expandable-open');
        this.wrapHeight = this.wrap.offsetHeight;
        this.wrap.classList.remove('expandable-open');
        if (this.isOpen) this.expand();
      }
    }
  }, {
    key: "expand",
    value: function expand() {
      this.wrap.style.height = this.wrapHeight + 'px';
      this.button.classList.add('expandable-open');
      this.isOpen = true;
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.button.classList.remove('expandable-open');
      this.wrap.style.height = 0;
      this.isOpen = false;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isOpen) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }]);
}();
var Expandables = /*#__PURE__*/function () {
  function Expandables() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-expandable]';
    expandables_classCallCheck(this, Expandables);
    this.selector = selector;
    this.modules = [];
    this.init();
  }
  return expandables_createClass(Expandables, [{
    key: "init",
    value: function init() {
      var _this = this;
      document.querySelectorAll(this.selector).forEach(function (element) {
        return _this.modules.push(new Expandable({
          container: element,
          isOpen: element.dataset.isopen
        }).init());
      });
    }
  }]);
}();
/* harmony default export */ const expandables = (Expandables);
;// ./src/js/modules/lazyload.js
function lazyload_typeof(o) { "@babel/helpers - typeof"; return lazyload_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, lazyload_typeof(o); }
function lazyload_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function lazyload_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, lazyload_toPropertyKey(o.key), o); } }
function lazyload_createClass(e, r, t) { return r && lazyload_defineProperties(e.prototype, r), t && lazyload_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function lazyload_toPropertyKey(t) { var i = lazyload_toPrimitive(t, "string"); return "symbol" == lazyload_typeof(i) ? i : i + ""; }
function lazyload_toPrimitive(t, r) { if ("object" != lazyload_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != lazyload_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LazyLoad = /*#__PURE__*/function () {
  function LazyLoad() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    lazyload_classCallCheck(this, LazyLoad);
    this.options = {
      selector: options.selector || 'img[loading="lazy"]',
      fallbackPlugin: options.fallbackPlugin || 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js'
    };
    this.init();
  }
  return lazyload_createClass(LazyLoad, [{
    key: "init",
    value: function init() {
      if (this.isNativeEnabled()) {
        this.enableNativeLazyLoading();
      } else {
        this.enableFallbackPlugin();
      }
    }
  }, {
    key: "isNativeEnabled",
    value: function isNativeEnabled() {
      return 'loading' in HTMLImageElement.prototype;
    }
  }, {
    key: "enableNativeLazyLoading",
    value: function enableNativeLazyLoading() {
      var images = document.querySelectorAll(this.options.selector);
      images.forEach(function (img) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
      });
    }
  }, {
    key: "enableFallbackPlugin",
    value: function enableFallbackPlugin() {
      var script = document.createElement("script");
      script.async = true;
      script.src = this.options.fallbackPlugin;
      document.body.appendChild(script);
    }
  }]);
}();
/* harmony default export */ const lazyload = (LazyLoad);
;// ./src/js/modules/accessibility.js
function accessibility_typeof(o) { "@babel/helpers - typeof"; return accessibility_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, accessibility_typeof(o); }
function accessibility_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function accessibility_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, accessibility_toPropertyKey(o.key), o); } }
function accessibility_createClass(e, r, t) { return r && accessibility_defineProperties(e.prototype, r), t && accessibility_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function accessibility_toPropertyKey(t) { var i = accessibility_toPrimitive(t, "string"); return "symbol" == accessibility_typeof(i) ? i : i + ""; }
function accessibility_toPrimitive(t, r) { if ("object" != accessibility_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != accessibility_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Accessibility = /*#__PURE__*/function () {
  function Accessibility(options) {
    accessibility_classCallCheck(this, Accessibility);
    this.options = Object.assign({
      tabClass: 'user-is-tabbing'
    }, options);
    this.handleTabbing = this.handleTabbing.bind(this);
    this.init();
  }
  return accessibility_createClass(Accessibility, [{
    key: "init",
    value: function init() {
      document.addEventListener('keydown', this.handleTabbing);
    }
  }, {
    key: "handleTabbing",
    value: function handleTabbing(e) {
      if (e.keyCode === 9) {
        // the "I am a keyboard user" key
        document.body.classList.add(this.options.tabClass);
        document.removeEventListener('keydown', this.handleTabbing);
      }
    }
  }]);
}();
/* harmony default export */ const accessibility = (Accessibility);
;// ./src/js/modules/header.js
function header_typeof(o) { "@babel/helpers - typeof"; return header_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, header_typeof(o); }
function header_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function header_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? header_ownKeys(Object(t), !0).forEach(function (r) { header_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : header_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function header_defineProperty(e, r, t) { return (r = header_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function header_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function header_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, header_toPropertyKey(o.key), o); } }
function header_createClass(e, r, t) { return r && header_defineProperties(e.prototype, r), t && header_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function header_toPropertyKey(t) { var i = header_toPrimitive(t, "string"); return "symbol" == header_typeof(i) ? i : i + ""; }
function header_toPrimitive(t, r) { if ("object" != header_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != header_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Header = /*#__PURE__*/function () {
  function Header(options) {
    header_classCallCheck(this, Header);
    this.options = Object.assign({
      selectors: {
        mobileMenu: '.js-mobile-menu',
        mobileMenuToggle: '.js-mobile-menu-toggle',
        mobileSubMenu: '.menu__dropdown',
        headerLink: '.menu__link',
        body: 'body'
      },
      classes: {
        menuOpen: 'mobile-menu-is-open',
        subMenuOpen: 'mobile-submenu-is-open'
      }
    }, options);
    this.s = this.options.selectors;
    this.c = this.options.classes;
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.openMobileMenu = this.openMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);
    this.init();
  }
  return header_createClass(Header, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.mobileMenuIsOpen = false;
      document.querySelectorAll(this.s.mobileMenuToggle).forEach(function (el) {
        return el.addEventListener('click', _this.toggleMobileMenu);
      });
      document.querySelectorAll(this.s.mobileSubMenu).forEach(function (el) {
        return new MobileSubMenu(el, header_objectSpread(header_objectSpread({}, _this.s), _this.c));
      });
    }
  }, {
    key: "openMobileMenu",
    value: function openMobileMenu() {
      if (this.mobileMenuIsOpen) return;
      this.mobileMenuIsOpen = true;
      Moonbase.Utils.addClass(document.querySelector(this.s.mobileMenu), this.options.classes.menuOpen);
      Moonbase.Utils.addClass(document.querySelector(this.s.mobileMenuToggle), this.options.classes.menuOpen);
      Moonbase.Utils.addClass(document.querySelector(this.s.body), this.options.classes.menuOpen);
    }
  }, {
    key: "closeMobileMenu",
    value: function closeMobileMenu() {
      if (!this.mobileMenuIsOpen) return;
      this.mobileMenuIsOpen = false;
      Moonbase.Utils.removeClass(document.querySelector(this.s.mobileMenu), this.options.classes.menuOpen);
      Moonbase.Utils.removeClass(document.querySelector(this.s.mobileMenuToggle), this.options.classes.menuOpen);
      Moonbase.Utils.removeClass(document.querySelector(this.s.body), this.options.classes.menuOpen);
    }
  }, {
    key: "toggleMobileMenu",
    value: function toggleMobileMenu() {
      if (this.mobileMenuIsOpen) {
        this.closeMobileMenu();
      } else {
        this.openMobileMenu();
      }
    }
  }]);
}();
var MobileSubMenu = /*#__PURE__*/function () {
  function MobileSubMenu(dropdown, selectors) {
    header_classCallCheck(this, MobileSubMenu);
    this.dropdown = dropdown;
    this.container = dropdown.parentElement;
    this.trigger = this.container.querySelector(selectors.headerLink);
    this.s = selectors;
    this.isOpen = false;
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.closeSubMenu = this.closeSubMenu.bind(this);
    this.openSubMenu = this.openSubMenu.bind(this);
    this.init();
  }
  return header_createClass(MobileSubMenu, [{
    key: "init",
    value: function init() {
      this.trigger.addEventListener('click', this.toggleSubMenu);
    }
  }, {
    key: "toggleSubMenu",
    value: function toggleSubMenu(e) {
      if (!Moonbase.header.mobileMenuIsOpen) return;
      if (e) e.preventDefault();
      if (this.isOpen) {
        this.closeSubMenu();
      } else {
        this.openSubMenu();
      }
    }
  }, {
    key: "closeSubMenu",
    value: function closeSubMenu() {
      Moonbase.Utils.removeClass(this.dropdown, this.s.subMenuOpen);
      this.isOpen = false;
    }
  }, {
    key: "openSubMenu",
    value: function openSubMenu() {
      Moonbase.Utils.addClass(this.dropdown, this.s.subMenuOpen);
      this.isOpen = true;
    }
  }]);
}();
/* harmony default export */ const header = (Header);
;// ./src/js/modules/detectIE.js
var isIE = function isIE() {
  return navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
};
var title = "Please upgrade your browser";
var content = "Your browser is out of date and won't work with this website, please call 01904 789559 for more info or to place an order.<br/> Please upgrade to a more up to date browser like <a href='https://www.google.co.uk/chrome'>Google Chrome</a>, <a href='https://www.mozilla.org/en-GB/firefox/new/'>Firefox</a> or <a href='https://www.microsoft.com/en-us/edge'>Edge</a>";
var modal = function modal() {
  return "\n<div class=\"modal micromodal-slide\" id=\"ie-modal\" aria-hidden=\"true\">\n    <div class=\"modal__overlay\" tabindex=\"-1\" data-micromodal-close>\n      <div class=\"modal__container\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"ie-modal-title\">\n        <button class=\"modal__close\" aria-label=\"Close modal\" data-micromodal-close></button>\n\n        <header class=\"modal__header\">\n            <h2 class=\"modal__title\" id=\"-title\">\n              ".concat(title, "\n            </h2>\n         </header>\n\n        <main class=\"modal__content\" id=\"-content\">\n          <p>").concat(content, "</p>\n        </main>\n      </div>\n    </div>\n</div>\n<style>\n  .modal__container {\n    padding: 40px;\n  }\n  .modal__header {\n    margin-bottom: 20px;\n  }\n  h2.modal__title {\n    text-align: center;\n    text-transform: uppercase;\n    width: 100%;\n    font-size: 30px;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n  .modal__content p {\n    text-align: center;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 18px;\n    line-height: 28px;\n  }\n</style>\n");
};
/* harmony default export */ const detectIE = (function () {
  if (!isIE() || localStorage.getItem('has-seen-ie-message')) return;
  var m = document.createElement('div');
  m.innerHTML = modal();
  document.body.appendChild(m);
  MicroModal.show('ie-modal');
  localStorage.setItem('has-seen-ie-message', 'true');
});
;// ./src/js/modules/innerZoom.js
var zoomSelector = '.js-inner-zoom';

// declare the module function
// As we don't export this, we cannot run this function from anywhere other than this file.
var innerZoom = function innerZoom(e) {
  var zoomer = e.currentTarget;
  // prevent offsetX is not defined error (no-undefs)
  var offsetX, offsetY, x, y;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches && e.touches[0].pageX;
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches && e.touches[0].pageX;
  x = offsetX / zoomer.offsetWidth * 100;
  y = offsetY / zoomer.offsetHeight * 100;
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
};
var initInnerZoom = function initInnerZoom() {
  // We will use the init function to attach the listeners to all product images that require a zoom.
  // select all images that require a zoom
  var zoomies = document.querySelectorAll(zoomSelector);

  // loop over each element using .forEach, equaivelant of $.each() in jQuery
  zoomies.forEach(function (el) {
    // remove event listener from all elements, this prevents having 2 listeners attached and running the function multiple times.
    el.removeEventListener('mousemove', innerZoom);
    // re-add the listener once to the element
    el.addEventListener('mousemove', innerZoom);
  });

  // Log to see when the innerZoom function is initialised, this will be logged twice on page
  // load due to us re-initialising when the product image slider mounts.
  //console.log('initInnerZoom was called');
};

// Export the init function so we can initialise in the glide.on callback
// Also imported in index.js, as any images that require the Zoom but aren't in the product image slider will also need initialising
/* harmony default export */ const modules_innerZoom = (initInnerZoom);

// If you wanted to also call the innerZoom function directly, you could export a child module like so:
// export { innerZoom };
;// ./src/js/modules/tabs.js
function tabs_typeof(o) { "@babel/helpers - typeof"; return tabs_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, tabs_typeof(o); }
function tabs_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function tabs_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, tabs_toPropertyKey(o.key), o); } }
function tabs_createClass(e, r, t) { return r && tabs_defineProperties(e.prototype, r), t && tabs_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function tabs_toPropertyKey(t) { var i = tabs_toPrimitive(t, "string"); return "symbol" == tabs_typeof(i) ? i : i + ""; }
function tabs_toPrimitive(t, r) { if ("object" != tabs_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != tabs_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = /*#__PURE__*/function () {
  /**
   * Creates and initialises a tabs instance
   * @param container {Element} Container element wrapping the tabs
   * @param options {Object} Object containing selectors and tab options
   */
  function Tabs() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('.js-tabs');
    var options = arguments.length > 1 ? arguments[1] : undefined;
    tabs_classCallCheck(this, Tabs);
    this.container = container;
    this.options = Object.assign({
      selectors: {
        triggers: '.js-tabs__trigger',
        tabs: '.js-tabs__tab'
      }
    }, options);
    this.triggers = this.container.querySelectorAll(this.options.selectors.triggers);
    this.tabs = this.container.querySelectorAll(this.options.selectors.tabs);
    this.init();
  }
  return tabs_createClass(Tabs, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.triggers.forEach(function (trigger) {
        trigger.addEventListener('click', _this.changeTab.bind(_this));
      });
    }
  }, {
    key: "changeTab",
    value: function changeTab(e) {
      var trigger = e.target.closest(this.options.selectors.triggers);
      var tabId = trigger.dataset.tabId;
      var tab = this.container.querySelector(this.options.selectors.tabs + '[data-tab-id="' + tabId + '"]');
      Array.from(this.triggers).filter(function (trigger) {
        return trigger.dataset.tabId !== tabId;
      }).forEach(function (trigger) {
        return trigger.classList.remove('active');
      });
      Array.from(this.tabs).filter(function (trigger) {
        return trigger.dataset.tabId !== tabId;
      }).forEach(function (trigger) {
        return trigger.classList.remove('active');
      });
      trigger.classList.add('active');
      tab.classList.add('active');
    }
  }]);
}();
/**
 * Automatically initialises tab instances matching the selector
 */
var AutoTabs = /*#__PURE__*/function () {
  function AutoTabs() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-tabs]';
    tabs_classCallCheck(this, AutoTabs);
    this.selector = selector;
    this.modules = [];
    this.init();
  }
  return tabs_createClass(AutoTabs, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      document.querySelectorAll(this.selector).forEach(function (element) {
        return _this2.modules.push(new Tabs(element));
      });
    }
  }]);
}();
/* harmony default export */ const tabs = (AutoTabs);

;// ./src/js/modules/qtySelector.js
function qtySelector_typeof(o) { "@babel/helpers - typeof"; return qtySelector_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, qtySelector_typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function qtySelector_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function qtySelector_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, qtySelector_toPropertyKey(o.key), o); } }
function qtySelector_createClass(e, r, t) { return r && qtySelector_defineProperties(e.prototype, r), t && qtySelector_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function qtySelector_toPropertyKey(t) { var i = qtySelector_toPrimitive(t, "string"); return "symbol" == qtySelector_typeof(i) ? i : i + ""; }
function qtySelector_toPrimitive(t, r) { if ("object" != qtySelector_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != qtySelector_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QtySelector = /*#__PURE__*/function () {
  function QtySelector(container) {
    var selectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
    qtySelector_classCallCheck(this, QtySelector);
    this.container = container;
    this.plus = container.querySelectorAll(selectors.plus);
    this.minus = container.querySelectorAll(selectors.minus);
    this.inputs = container.querySelectorAll(selectors.input);
    this.selectors = selectors;
    this.minValue = 1;
    this.quantity = 1;
    var _iterator = _createForOfIteratorHelper(this.inputs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var input = _step.value;
        var min = input.getAttribute('min');
        this.quantity = input.value;
        if (min) {
          this.minValue = min;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    this.getQuantity = this.getQuantity.bind(this);
    this.change = this.change.bind(this);
    this.onPlus = this.onPlus.bind(this);
    this.onMinus = this.onMinus.bind(this);
    this.init();
  }
  return qtySelector_createClass(QtySelector, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.plus.forEach(function (el) {
        el.addEventListener('click', this.onPlus.bind(this));
      }.bind(this));
      this.minus.forEach(function (el) {
        el.addEventListener('click', this.onMinus.bind(this));
      }.bind(this));
      this.inputs.forEach(function (el) {
        el.addEventListener('change', function (e) {
          return _this.change(_this.getQuantity(e.target.value));
        });
      });
    }
  }, {
    key: "onPlus",
    value: function onPlus() {
      this.change(this.getQuantity(this.quantity) + 1);
    }
  }, {
    key: "onMinus",
    value: function onMinus() {
      this.change(this.getQuantity(this.quantity) - 1);
    }
  }, {
    key: "getQuantity",
    value: function getQuantity() {
      var qty = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quantity;
      if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        qty = 1;
      }
      return parseInt(qty);
    }
  }, {
    key: "change",
    value: function change(value) {
      if (value < this.minValue) {
        value = this.minValue;
      }
      this.quantity = value;
      this.container.querySelectorAll(this.selectors.input).forEach(function (el) {
        el.value = value;
      });
    }
  }]);
}();
/* harmony default export */ const qtySelector = (QtySelector);
;// ./node_modules/@shopify/theme-sections/section.js
var SECTION_ID_ATTR = 'data-section-id';

function Section(container, properties) {
  this.container = validateContainerElement(container);
  this.id = container.getAttribute(SECTION_ID_ATTR);
  this.extensions = [];

  // eslint-disable-next-line es5/no-es6-static-methods
  Object.assign(this, validatePropertiesObject(properties));

  this.onLoad();
}

Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,

  extend: function extend(extension) {
    this.extensions.push(extension); // Save original extension

    // eslint-disable-next-line es5/no-es6-static-methods
    var extensionClone = Object.assign({}, extension);
    delete extensionClone.init; // Remove init function before assigning extension properties

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, extensionClone);

    if (typeof extension.init === 'function') {
      extension.init.apply(this);
    }
  }
};

function validateContainerElement(container) {
  if (!(container instanceof Element)) {
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  }
  if (container.getAttribute(SECTION_ID_ATTR) === null) {
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' +
        SECTION_ID_ATTR +
        ' attribute.'
    );
  }

  return container;
}

function validatePropertiesObject(value) {
  if (
    (typeof value !== 'undefined' && typeof value !== 'object') ||
    value === null
  ) {
    throw new TypeError(
      'Theme Sections: The properties object provided is not a valid'
    );
  }

  return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

;// ./node_modules/@shopify/theme-sections/theme-sections.js
/* unused harmony import specifier */ var theme_sections_Section;
/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */



var SECTION_TYPE_ATTR = 'data-section-type';
var theme_sections_SECTION_ID_ATTR = 'data-section-id';

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

var registered = (window.Shopify.theme.sections.registered =
  window.Shopify.theme.sections.registered || {});
var instances = (window.Shopify.theme.sections.instances =
  window.Shopify.theme.sections.instances || []);

function register(type, properties) {
  if (typeof type !== 'string') {
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  }

  if (typeof registered[type] !== 'undefined') {
    throw new Error(
      'Theme Sections: A section of type "' +
        type +
        '" has already been registered. You cannot register the same section type twice'
    );
  }

  function TypedSection(container) {
    theme_sections_Section.call(this, container, properties);
  }

  TypedSection.constructor = theme_sections_Section;
  TypedSection.prototype = Object.create(theme_sections_Section.prototype);
  TypedSection.prototype.type = type;

  return (registered[type] = TypedSection);
}

function unregister(types) {
  types = normalizeType(types);

  types.forEach(function(type) {
    delete registered[type];
  });
}

function load(types, containers) {
  types = normalizeType(types);

  if (typeof containers === 'undefined') {
    containers = document.querySelectorAll('[' + SECTION_TYPE_ATTR + ']');
  }

  containers = normalizeContainers(containers);

  types.forEach(function(type) {
    var TypedSection = registered[type];

    if (typeof TypedSection === 'undefined') {
      return;
    }

    containers = containers.filter(function(container) {
      // Filter from list of containers because container already has an instance loaded
      if (isInstance(container)) {
        return false;
      }

      // Filter from list of containers because container doesn't have data-section-type attribute
      if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
        return false;
      }

      // Keep in list of containers because current type doesn't match
      if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
        return true;
      }

      instances.push(new TypedSection(container));

      // Filter from list of containers because container now has an instance loaded
      return false;
    });
  });
}

function unload(selector) {
  var instancesToUnload = getInstances(selector);

  instancesToUnload.forEach(function(instance) {
    var index = instances
      .map(function(e) {
        return e.id;
      })
      .indexOf(instance.id);
    instances.splice(index, 1);
    instance.onUnload();
  });
}

function theme_sections_extend(selector, extension) {
  var instancesToExtend = getInstances(selector);

  instancesToExtend.forEach(function(instance) {
    instance.extend(extension);
  });
}

function getInstances(selector) {
  var filteredInstances = [];

  // Fetch first element if its an array
  if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
    var firstElement = selector[0];
  }

  // If selector element is DOM element
  if (selector instanceof Element || firstElement instanceof Element) {
    var containers = normalizeContainers(selector);

    containers.forEach(function(container) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.container === container;
        })
      );
    });

    // If select is type string
  } else if (typeof selector === 'string' || typeof firstElement === 'string') {
    var types = normalizeType(selector);

    types.forEach(function(type) {
      filteredInstances = filteredInstances.concat(
        instances.filter(function(instance) {
          return instance.type === type;
        })
      );
    });
  }

  return filteredInstances;
}

function getInstanceById(id) {
  var instance;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].id === id) {
      instance = instances[i];
      break;
    }
  }
  return instance;
}

function isInstance(selector) {
  return getInstances(selector).length > 0;
}

function normalizeType(types) {
  // If '*' then fetch all registered section types
  if (types === '*') {
    types = Object.keys(registered);

    // If a single section type string is passed, put it in an array
  } else if (typeof types === 'string') {
    types = [types];

    // If single section constructor is passed, transform to array with section
    // type string
  } else if (types.constructor === Section) {
    types = [types.prototype.type];

    // If array of typed section constructors is passed, transform the array to
    // type strings
  } else if (Array.isArray(types) && types[0].constructor === Section) {
    types = types.map(function(TypedSection) {
      return TypedSection.prototype.type;
    });
  }

  types = types.map(function(type) {
    return type.toLowerCase();
  });

  return types;
}

function normalizeContainers(containers) {
  // Nodelist with entries
  if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
    containers = Array.prototype.slice.call(containers);

    // Empty Nodelist
  } else if (
    NodeList.prototype.isPrototypeOf(containers) &&
    containers.length === 0
  ) {
    containers = [];

    // Handle null (document.querySelector() returns null with no match)
  } else if (containers === null) {
    containers = [];

    // Single DOM element
  } else if (!Array.isArray(containers) && containers instanceof Element) {
    containers = [containers];
  }

  return containers;
}

if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
    );

    if (container !== null) {
      load(container.getAttribute(SECTION_TYPE_ATTR), container);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var id = event.detail.sectionId;
    var container = event.target.querySelector(
      '[' + theme_sections_SECTION_ID_ATTR + '="' + id + '"]'
    );
    var instance = getInstances(container)[0];

    if (typeof instance === 'object') {
      unload(container);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onSelect(event);
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onDeselect(event);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockSelect(event);
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    var instance = getInstanceById(event.detail.sectionId);

    if (typeof instance === 'object') {
      instance.onBlockDeselect(event);
    }
  });
}

;// ./src/js/templates/index.js
/* harmony default export */ const templates = ([{
  templates: ['cart'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/cart.js?v=182766308142384891701793204541"
}, {
  templates: ['product'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/product.js?v=159465021952814503311775557049"
}, {
  templates: ['customers/login', 'customers/register'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/login.js?v=149538885175511652691775557049"
}, {
  templates: ['customers/addresses'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/addresses.js?v=111001391408294135701775557046"
}, {
  templates: ['customers/account'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/account.js?v=131812426012772177191775557046"
}, {
  templates: ['collection'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/collection.js?v=123595176212379707511775557048"
}, {
  templates: ['captcha'],
  path: "//www.scnutra.com/cdn/shop/t/14/assets/captcha.js?v=13945294002254069761775557047"
}]);
;// ./src/js/sections.js
function sections_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = sections_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function sections_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return sections_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? sections_arrayLikeToArray(r, a) : void 0; } }
function sections_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


/* harmony default export */ const sections = (function (sections) {
  sections = sections.concat(templates);
  var imports = sections.filter(function (template) {
    if (template.sections) {
      var _iterator = sections_createForOfIteratorHelper(template.sections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          if (document.querySelector('[data-section-type="' + section + '"]')) return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      return template.templates.indexOf(Moonbase.template) > -1;
    }
  });
  var promises = [];
  var _iterator2 = sections_createForOfIteratorHelper(imports),
    _step2;
  try {
    var _loop = function _loop() {
      var i = _step2.value;
      var promise = new Promise(function (resolve) {
        var script = document.createElement('script');
        var scripts = document.getElementsByTagName('script')[0];
        script.src = i.path || "/" + i + ".js";
        script.onload = resolve;
        scripts.parentNode.insertBefore(script, scripts);
      });
      promises.push(promise);
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return Promise.all(promises).then(function () {
    return load('*');
  });
});
;// ./src/js/index.js


// Utilities




// Imported modules


// Custom modules










// Templates


// Initialisation code
(function () {
  console.log('🚀 Shopify Theme by Brave The Skies');
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
  detectIE();

  /* Initialise a global Moonbase variable
     that can be accessed on the front end
     if not already defined. */
  var Moonbase = window.Moonbase || {};

  /* init GoCart.js
     You can overwrite these default options in theme.liquid:
     Moonbase = window.Moonbase || {};
     Moonbase.ajaxCartOptions = { ...options }; */
  Moonbase.ajaxCart = new modules_GoCart(Object.assign({
    cartMode: 'drawer',
    // drawer or mini-cart
    drawerDirection: 'right',
    // cart drawer from left or right
    displayModal: false,
    // display success modal when adding product to cart
    moneyFormat: Moonbase.settings.moneyFormat // template for money format when displaying money
  }, Moonbase.ajaxCartOptions));
  /***/

  // Run any custom modules here
  new accessibility();
  new expandables();
  new tabs();
  Moonbase.lazyLoad = new lazyload();
  Moonbase.header = new header();
  modules_innerZoom();
  Moonbase.QtySelector = qtySelector;
  micromodal_es.init({
    disableFocus: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    onShow: function onShow(modal) {
      modal.querySelectorAll('[data-micromodal-close]').forEach(function (el) {
        return el.setAttribute('tabindex', '0');
      });
      modal.querySelector('.modal__container').focus();
    },
    onClose: function onClose(modal) {
      modal.querySelectorAll('[data-micromodal-close]').forEach(function (el) {
        return el.setAttribute('tabindex', '0');
      });
    }
  });

  // used to dynamically load template & section js per page.
  // prevents loading js that isn't required
  // Add sections in theme-js.liquid:
  // Moonbase.sections = [
  //      ...
  //     'my-new-section'
  // ]
  sections(Moonbase.sections)["catch"](function (e) {
    return console.log('Error loading template files', e);
  });

  // Re-trigger lazy load when sections are re-loaded in customise
  document.addEventListener('shopify:section:load', function () {
    return Moonbase.lazyLoad.init();
  });

  // loop over each registered module and initialise
  for (var _i = 0, _Object$values = Object.values(Moonbase.modules || {}); _i < _Object$values.length; _i++) {
    var moduleInitFunction = _Object$values[_i];
    moduleInitFunction();
  }
})();
})();

// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

/******/ })()
;